import INotFoundHttpErrorResponse from '../../interfaces/BadRequest/INotFoundHttpErrorResponse';
import BadRequestHttpError from '../BadRequestHttpError';

export default class NotFoundHttpError extends BadRequestHttpError<INotFoundHttpErrorResponse> {
    constructor(response: INotFoundHttpErrorResponse) {
        super('Not found!', response);
    }
}
